import React from "react";
import { useLang } from "../context/LangContext";

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how" data-testid="how-section" className="py-24 lg:py-32 bg-[#050505] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00E5FF]/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <div className="flex items-center gap-4 mb-6">
            <span className="block w-12 h-px bg-[#00E5FF]" />
            <span className="label-eyebrow text-[#00E5FF]">{t.how.eyebrow}</span>
          </div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            {t.how.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {t.how.steps.map((step, i) => (
            <div key={i} className="bg-[#050505] p-8 lg:p-10 hover:bg-[#0a0a0a] transition-all duration-500 group">
              <div className="font-display text-7xl text-[#00E5FF]/20 group-hover:text-[#00E5FF] transition-colors duration-500 mb-6">
                {step.n}
              </div>
              <h3 className="font-display uppercase text-xl tracking-wider text-white mb-3">{step.title}</h3>
              <p className="text-neutral-400 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
